import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";

const TopBar = () => {
  const { project_id } = useParams();

  const [status, setStatus] = useState(0);
  const { apiURL, apiHeaderJson } = useContext(ConfigContext);

  const navigate = useNavigate();
  const DoNavigate = (route) => {
    navigate(route);
  };

  const handlRadioChange = (value) => {
    setStatus(value);
  };
  const handleStatus = async () => {
    const headers = apiHeaderJson;
    const body = {
      project_status: status,
      project_id: project_id,
      created_by: localStorage.getItem("user_id"),
    };
    try {
      const response = await axios.put(
        `${apiURL}api/projects/${project_id}`,
        body,
        { headers }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Project Status Updated Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        document.getElementById("close-modal")?.click();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const GetProfileInfo = async () => {
    try {
      const response = await axios.get(`${apiURL}api/projects/${project_id}`);
      const data = response.data;
      if (data.success) {
        setStatus(data.data.project_status || 0);
      } else {
        setStatus("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetProfileInfo();
  }, []);

  return (
    <div className="d-flex profile-wrapper">
      <ul
        className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <NavLink
            to={"/ProjectProfile"}
            onClick={() => DoNavigate(`/ProjectProfile/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#overview-tab"
            role="tab"
            aria-selected="true"
          >
            <i className="ri-airplay-fill d-inline-block d-md-none" />{" "}
            <span className="d-none d-md-inline-block">Overview</span>
          </NavLink>
        </li>
        <li className="nav-item" role="presentation">
          <NavLink
            to={"/Documents"}
            onClick={() => DoNavigate(`/Documents/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#documents"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-folder-4-line d-inline-block d-md-none" />
            <span className="d-none d-md-inline-block">Documents</span>
          </NavLink>
        </li>
        <li className="nav-item" role="presentation">
          <NavLink
            to={"/ContractorList"}
            onClick={() => DoNavigate(`/ContractorList/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#contractor"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-list-unordered d-inline-block d-md-none" />
            <span className="d-none d-md-inline-block">Contractor List</span>
          </NavLink>
        </li>
        <li className="nav-item" role="presentation">
          <NavLink
            to={"/ConsultantList"}
            onClick={() => DoNavigate(`/ConsultantList/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#consultant"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-list-unordered d-inline-block d-md-none" />{" "}
            <span className="d-none d-md-inline-block">Consultant List</span>
          </NavLink>
        </li>


        <li className="nav-item" role="presentation">
          <NavLink
            to={"/AssignedItems"}
            onClick={() => DoNavigate(`/AssignedItems/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#Task"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-folder-4-line d-inline-block d-md-none" />{" "}
            <span className="d-none d-md-inline-block">Assigned Items</span>
          </NavLink>
        </li>

        <li className="nav-item" role="presentation">
          <NavLink
            to={"/Gallery"}
            onClick={() => DoNavigate(`/Gallery/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#Gallery"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-folder-4-line d-inline-block d-md-none" />{" "}
            <span className="d-none d-md-inline-block">Gallery</span>
          </NavLink>
        </li>

        <li className="nav-item" role="presentation">
          <NavLink
            to={"/Task"}
            onClick={() => DoNavigate(`/Task/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#Task"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-folder-4-line d-inline-block d-md-none" />{" "}
            <span className="d-none d-md-inline-block">Task</span>
          </NavLink>
        </li>



        <li className="nav-item" role="presentation">
          <NavLink
            to={"/AllItemRequest"}
            onClick={() => DoNavigate(`/AllItemRequest/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#Task"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-folder-4-line d-inline-block d-md-none" />{" "}
            <span className="d-none d-md-inline-block">Request</span>
          </NavLink>
        </li>




        {/* <li className="nav-item" role="presentation">
          <NavLink
            to={"/Inspection"}
            onClick={() => DoNavigate(`/Inspection/${project_id}`)}
            className="nav-link fs-14"
            data-bs-toggle="tab"
            href="#Task"
            role="tab"
            aria-selected="false"
            tabIndex={-1}
          >
            <i className="ri-folder-4-line d-inline-block d-md-none" />{" "}
            <span className="d-none d-md-inline-block">Inspection</span>
          </NavLink>
        </li> */}
      </ul>

    </div>
  );
};

export default TopBar;
